import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class AssociationChargeDetail {
    constructor(doc)
    {
		this.label = null
		this.associationChargeAmount = null;
		this.associationChargeBalanceAmount = null;
		this.associationChargePeriodType = null
		this.associationChargeType = null
		this.associationSpecialAssessmentStatusType = null
		this.ownershipTransferFeeIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.associationChargeAmount  = x.getMISMOAmountElement(doc, "./ns:AssociationChargeAmount");
		this.associationChargeBalanceAmount  = x.getMISMOAmountElement(doc, "./ns:AssociationChargeBalanceAmount");
		this.associationChargePeriodType = x.getStringElement(doc, "./ns:AssociationChargePeriodType");
		this.associationChargeType = x.getStringElement(doc, "./ns:AssociationChargeType");
		this.associationSpecialAssessmentStatusType = x.getStringElement(doc, "./ns:AssociationSpecialAssessmentStatusType");
		this.ownershipTransferFeeIndicator = x.getBooleanElement(doc, "./ns:OwnershipTransferFeeIndicator");
   }
}

export class AssociationChargeIncludesUtility {
    constructor(doc)
    {
		this.label = null
		this.associationChargeIncludesUtilityType = null
		this.associationChargeIncludesUtilityTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.associationChargeIncludesUtilityType = x.getStringElement(doc, "./ns:AssociationChargeIncludesUtilityType");
		this.associationChargeIncludesUtilityTypeOtherDescription = x.getStringElement(doc, "./ns:AssociationChargeIncludesUtilityTypeOtherDescription");
   }

	GetUtilityType() {
		return h.descriptionOrOther(this.associationChargeIncludesUtilityType, this.associationChargeIncludesUtilityTypeOtherDescription);
	}

}

export class AssociationCharge {
  constructor(doc) {
		this.label = null
		this.associationChargeDetail = null
		this.associationChargeIncludesUtilities = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:ASSOCIATION_CHARGE_DETAIL");
		if (node !== null)
				this.associationChargeDetail = new AssociationChargeDetail(node);
		nodes = x.selectNodes(doc, "./ns:ASSOCIATION_CHARGE_INCLUDES_UTILITIES/ns:ASSOCIATION_CHARGE_INCLUDES_UTILITY");
		if (nodes.length > 0) {
			nodes.forEach((xn) => {
				this.associationChargeIncludesUtilities.push(new AssociationChargeIncludesUtility(xn));
			});
		}
  }

	GetStatusType() {
		return h.toEnumText(this.associationChargeDetail.associationSpecialAssessmentStatusType);
	}

	GetChargeType() {
		return h.descriptionOrOther(this.associationChargeDetail.associationChargeType, this.associationChargeDetail.associationChargeTypeOtherDescription);
	}

	GetUtilitesIncluded() {
		var list = "";
		if (this.associationChargeIncludesUtilities.length > 0)
			for (var aciu of this.associationChargeIncludesUtilities)
				list.push(h.addWithSpacer(list, aciu.GetUtilityType()));
		return list;
	}

	GetUtilitesIncludedList() {
		var list = [];
		if (this.associationChargeIncludesUtilities.length > 0)
			for (var aciu of this.associationChargeIncludesUtilities)
				list.push(aciu.GetUtilityType());
		return list;
	}

}

export class HomeownersAssociations {
    constructor(doc)	{
		this.label = null
		this.associationCharges = []
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:HOMEOWNERS_ASSOCIATIONS/ns:HOMEOWNERS_ASSOCIATION/ns:ASSOCIATION_CHARGES/ns:ASSOCIATION_CHARGE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.associationCharges.push(new AssociationCharge(xn));
			});
		}
   }

	GetAssociationCharges(type) {
		var list = [];
		if (this.associationCharges.length > 0)
			for (var charge of this.associationCharges)
		 		if (charge.associationChargeDetail.associationChargeType === type)
					list.push(charge);

		return list;
	}

	GetOwnershipTransferFeeIndicator() {
		if (this.associationCharges.length > 0)
			for (var charge of this.associationCharges)
				if (charge.associationChargeDetail !== null)
					return (charge.associationChargeDetail.OwnershipTransferFeeIndicator ?? false) ;
		return false;
	}

	GetAssociationChargeAmount(type) {
		if (this.associationCharges.length === 0) return null;
		for (var charge of this.associationCharges)
			if (charge.associationChargeDetail !== null)
				if (charge.associationChargeDetail.associationChargeType === type)
					return (charge.associationChargeDetail.associationChargeAmount.ToDollarAmount());
		return null;
	}

	GetSpecialAssessmentStatusType() {
		if (this.associationCharges.length === 0) return null;
		for (var charge of this.associationCharges)
			if (charge.associationChargeDetail !== null)
				if (charge.associationChargeDetail.associationChargeType === "AssociationSpecialAssessment")
					return h.toEnumText(charge.associationChargeDetail.associationSpecialAssessmentStatusType);
		return null;
	}

	GetUtilitesIncluded() {
	var list = "";
	if (this.associationCharges.length === 0) return null;
	for (var charge of this.associationCharges)
		if (charge.associationChargeIncludesUtilities !== null)
			for (var aciu of charge.associationChargeIncludesUtilities)
				list.push(h.addWithSpacer(list, aciu.GetUtilityType()));
	return list;
	}

}

